/* ============================================================
   BANNER DE COLECAO — cor do titulo conforme o fundo.

   Le a imagem do banner (a que o navegador esta exibindo, desktop ou
   mobile), mede o brilho medio so da area atras do titulo e troca a
   cor do texto: claro sobre fundo escuro, escuro sobre fundo claro.

   - O limiar (LIMIAR) fica proposital acima do "meio" matematico: o
     laranja da marca (luminancia ~0.29) continua com titulo branco, que
     e o visual atual. So fundos realmente claros viram titulo escuro.
   - Se a imagem nao puder ser lida (CORS, erro de rede), nada muda: o
     titulo segue com a cor configurada no tema.
   - Para desligar num banner especifico: data-contraste="off" no h1.
   Carregado so no template de colecao (layout/theme.liquid).
   ============================================================ */
(function () {
  'use strict';

  var CLARO = '#ffffff';
  /* Cores da marca: o titulo e grande, entao usa o laranja quando ele passa
     em contraste 3:1 (WCAG, texto grande) sobre o fundo medido; senao, marrom. */
  var MARROM = '#362017';
  var LARANJA = '#ec6731';
  var LUM_LARANJA = 0.288; /* luminancia relativa de #ec6731 */
  var LIMIAR = 0.4; /* luminancia relativa (0 = preto, 1 = branco) */
  var AMOSTRA = 320; /* largura maxima do canvas de leitura, em px */
  var MARGEM = 8; /* folga em volta do texto, em px de tela */

  var cache = {}; /* src -> Promise de { data, w, h, nw, nh } */

  var LIN = [];
  for (var i = 0; i < 256; i++) {
    var c = i / 255;
    LIN[i] = c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }

  function carregar(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var nw = im.naturalWidth;
          var nh = im.naturalHeight;
          var w = Math.min(AMOSTRA, nw);
          var h = Math.max(1, Math.round(nh * (w / nw)));
          var cv = document.createElement('canvas');
          cv.width = w;
          cv.height = h;
          var ctx = cv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0, w, h);
          resolve({ data: ctx.getImageData(0, 0, w, h).data, w: w, h: h, nw: nw, nh: nh });
        } catch (e) {
          reject(e); /* canvas "tainted" */
        }
      };
      im.onerror = reject;
      im.src = src;
    });
    return cache[src];
  }

  /* Retangulo do texto em coordenadas da imagem exibida -> pixels da amostra. */
  function regiao(img, titulo, amostra) {
    var ir = img.getBoundingClientRect();
    var range = document.createRange();
    range.selectNodeContents(titulo);
    var tr = range.getBoundingClientRect();
    if (!ir.width || !ir.height || !tr.width || !tr.height) return null;

    var fit = getComputedStyle(img).objectFit;
    var sx = ir.width / amostra.nw;
    var sy = ir.height / amostra.nh;
    var s = fit === 'cover' ? Math.max(sx, sy) : fit === 'contain' ? Math.min(sx, sy) : null;
    var ox = 0;
    var oy = 0;
    if (s === null) {
      sx = ir.width / amostra.nw;
      sy = ir.height / amostra.nh;
    } else {
      sx = sy = s;
      ox = (ir.width - amostra.nw * s) / 2; /* object-position: centro */
      oy = (ir.height - amostra.nh * s) / 2;
    }

    var k = amostra.w / amostra.nw; /* natural -> amostra */
    var x0 = ((tr.left - MARGEM - ir.left - ox) / sx) * k;
    var x1 = ((tr.right + MARGEM - ir.left - ox) / sx) * k;
    var y0 = ((tr.top - MARGEM - ir.top - oy) / sy) * k;
    var y1 = ((tr.bottom + MARGEM - ir.top - oy) / sy) * k;

    x0 = Math.max(0, Math.floor(x0));
    y0 = Math.max(0, Math.floor(y0));
    x1 = Math.min(amostra.w, Math.ceil(x1));
    y1 = Math.min(amostra.h, Math.ceil(y1));
    if (x1 <= x0 || y1 <= y0) return null;
    return { x0: x0, y0: y0, x1: x1, y1: y1 };
  }

  function luminancia(amostra, r) {
    var soma = 0;
    var n = 0;
    for (var y = r.y0; y < r.y1; y++) {
      for (var x = r.x0; x < r.x1; x++) {
        var p = (y * amostra.w + x) * 4;
        var a = amostra.data[p + 3] / 255;
        if (a === 0) continue;
        soma += (0.2126 * LIN[amostra.data[p]] + 0.7152 * LIN[amostra.data[p + 1]] + 0.0722 * LIN[amostra.data[p + 2]]) * a + (1 - a);
        n++;
      }
    }
    return n ? soma / n : null;
  }

  function pintar(titulo, cor) {
    titulo.style.setProperty('color', cor, 'important');
    var filhos = titulo.querySelectorAll('*');
    for (var i = 0; i < filhos.length; i++) filhos[i].style.setProperty('color', cor, 'important');
  }

  function ajustar(bloco, titulo) {
    var img = bloco.querySelector('img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    carregar(src)
      .then(function (amostra) {
        var r = regiao(img, titulo, amostra);
        if (!r) return;
        var l = luminancia(amostra, r);
        if (l === null) return;
        if (l <= LIMIAR) return pintar(titulo, CLARO);
        pintar(titulo, (l + 0.05) / (LUM_LARANJA + 0.05) >= 3 ? LARANJA : MARROM);
      })
      .catch(function () {
        /* sem leitura possivel: mantem a cor do tema */
      });
  }

  function iniciar() {
    var titulos = document.querySelectorAll('.image-block .image-block__content-wrapper h1');
    Array.prototype.forEach.call(titulos, function (titulo) {
      if (titulo.getAttribute('data-contraste') === 'off') return;
      var bloco = titulo.closest('.image-block');
      if (!bloco) return;

      var timer = null;
      function agendar() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          ajustar(bloco, titulo);
        }, 150);
      }

      ajustar(bloco, titulo);
      var img = bloco.querySelector('img');
      if (img) img.addEventListener('load', agendar);
      window.addEventListener('resize', agendar);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(agendar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
